import { Logger } from '@syonet/lang'
import { BffRestClient } from '@whatsapp/communication'

const LOG = new Logger('EurekaService')

// @Inject
const bffClient = BffRestClient.singleton()

let usingLocalTunnel = false

let usingLocalhost = false

function static_computeEurekaUrl() {
    const locationUrl = new URL(window.location.href)

    const configJson = localStorage.getItem('syowhatsapp') || '{}'
    const config = JSON.parse(configJson)

    if (config.eureka) {
        return config.eureka
    }

    if (locationUrl.hostname.indexOf('staging.') !== -1) {
        return 'https://eureka.staging.prod.whatsapp.syonet.com'
    }

    if (locationUrl.hostname.indexOf('gupshup.') !== -1) {
        return 'https://eureka.gupshup.prod.whatsapp.syonet.com'
    }

    if (locationUrl.hostname.indexOf('prod.') !== -1) {
        return 'https://eureka.prod.whatsapp.syonet.com'
    }

    if (locationUrl.hostname.indexOf('internal.') !== -1) {
        return 'https://eureka.internal.syonet.com'
    }

    if (locationUrl.hostname.indexOf('.loca.lt') !== -1) {
        usingLocalTunnel = true
        return `https://syo-whats-app-bus.loca.lt`
    }

    usingLocalhost = true

    return `http://localhost:3072`
}

export class EurekaService {
    private static readonly INSTANCE = new EurekaService()

    public static singleton() {
        return EurekaService.INSTANCE
    }

    // :: Instance

    private __initialized = false

    public get name() {
        return 'syo-eureka-service'
    }

    public get initialized(): boolean {
        return this.__initialized
    }

    public async postConstruct() {
        bffClient.eurekaEndpoint = static_computeEurekaUrl()
        bffClient.useInternalHosts = false
        await bffClient.refreshEndpoints()
        this.__initialized = true
        LOG.info('Initialized')
    }

    public async preDestroy() {
        this.__initialized = false
        LOG.info('Finalized')
    }

    // :: API

    public get usingLocalTunnel() {
        return usingLocalTunnel
    }

    public get usingLocalhost() {
        return usingLocalhost
    }

    public endpoint() {
        return static_computeEurekaUrl()
    }

    public async refresh() {
        await bffClient.refreshEndpoints()
    }

    public getInfobipMiddlewareEndpoint() {
        return bffClient.infobipMiddlewareEndPoint
    }

    public getSyoWhatsAppBusEndPoint() {
        return bffClient.whatsappBusEndPoint
    }

    public getSyoReportsEndpoint() {
        return bffClient.syoReportsEndPoint
    }

    public getSyoMessengerEndpoint() {
        return bffClient.serverMessengerEndPoint
    }

    public getSyoMiddlewareEndpoint() {
        return bffClient.syonetMiddlewareEndPoint
    }

    public getSyoRoomManagerEndpoint() {
        return bffClient.roomManagerEndPoint
    }

    public getSyoAliceBotEndpoint() {
        return bffClient.syoBotAliceEndPoint
    }
}
